import { render, staticRenderFns } from "./CadastroNovaSenha.vue?vue&type=template&id=2408fd5e&scoped=true"
import script from "./CadastroNovaSenha.vue?vue&type=script&lang=js"
export * from "./CadastroNovaSenha.vue?vue&type=script&lang=js"
import style0 from "./CadastroNovaSenha.vue?vue&type=style&index=0&id=2408fd5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2408fd5e",
  null
  
)

export default component.exports